export enum HistoryPageNavbarLayoutVariant {
  Default = "default",
  Compact = "compact",
}

export const getHistoryPageNavbarLayoutVariant = (
  compactTitle: boolean,
): HistoryPageNavbarLayoutVariant =>
  compactTitle ? HistoryPageNavbarLayoutVariant.Compact : HistoryPageNavbarLayoutVariant.Default;

export const getHistoryPageNavbarGridClassName = (_compactTitle: boolean): string =>
  "grid grid-cols-[minmax(90px,1fr)_minmax(0,max-content)] items-start gap-x-2 gap-y-2";

export const getHistoryPageNavbarTitleClassName = (compactTitle: boolean): string =>
  compactTitle
    ? "min-w-0 truncate text-[20px] font-semibold text-gray-900"
    : "min-w-0 truncate text-2xl font-semibold text-gray-900";

export const getHistoryPageNavbarActionsClassName = (_compactTitle: boolean): string =>
  "flex min-w-0 flex-nowrap items-center justify-end gap-2 text-gray-800 hover:text-gray-700";

export const getHistoryPageNavbarMetadataClassName = (): string =>
  "col-span-2 flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-sm text-gray-600";

export const getHistoryPageNavbarResourceLinksClassName = (): string => "col-span-2 min-w-0";
